<template>
    <div class="custom-select" :class="{ 'is-disabled': disabled }">
        <div class="custom-select__selected" @mousedown.prevent="openDropdown">
            <input
                type="text"
                class="el-select__input"
                v-if="isOpen"
                v-model="filterText"
                @click.stop
                @blur="onBlur"
            />
            <span class="text-wrap" v-else :style="{ color: selectedOption ? '#000' : '#aaa' }">
                {{ selectedOption?.label || placeholder }}
            </span>
            <i class="custom-select__arrow">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
                    <path
                        fill="currentColor"
                        d="M831.872 340.864 512 652.672 192.128 340.864a30.592 30.592 0 0 0-42.752 0 29.12 29.12 0 0 0 0 41.6L489.664 714.24a32 32 0 0 0 44.672 0l340.288-331.712a29.12 29.12 0 0 0 0-41.728 30.592 30.592 0 0 0-42.752 0z"
                    />
                </svg>
            </i>
        </div>
        <div v-if="isOpen" class="custom-select__dropdown">
            <div
                v-for="option in filteredOptions"
                :key="option.value"
                class="custom-select__option"
                @mousedown.prevent="selectOption(option)"
            >
                {{ option.label }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CustomSelect',
    props: {
        options: {
            type: Array,
            required: true,
        },
        modelValue: {
            type: [String, Number, null],
            default: null,
        },
        propVal: {
            type: [String, Number, null],
            default: null,
        },
        placeholder: {
            type: String,
            default: 'Select',
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isOpen: false,
            filterText: null,
        };
    },
    computed: {
        selectedOption() {
            return this.options.find(opt => opt.value === this.modelValue);
        },
        filteredOptions() {
            if (!this.filterText) return this.options;
            const text = this.filterText.toLowerCase();
            return this.options.filter(opt => (opt.label || '').toLowerCase().includes(text));
        }
    },
    methods: {
        openDropdown() {
            if (this.disabled) return;
            this.isOpen = true;
            this.$nextTick(() => {
                const input = this.$el.querySelector('input');
                if (input) input.focus();
            });
        },
        closeDropdown() {
            this.isOpen = false;
        },
        selectOption(option) {
            this.$emit('update:modelValue', option.value);
            this.isOpen = false;
        },
        handleClickOutside(e) {
            if (!this.$el.contains(e.target)) {
                this.closeDropdown();
            }
        },
        onBlur() {
            // Отложим закрытие, чтобы успел выполниться mousedown по элементу
            setTimeout(() => {
                this.closeDropdown();
            }, 150);
        }
    },
    watch: {
        isOpen(val) {
            if (val) {
                document.addEventListener('click', this.handleClickOutside);
            } else {
                document.removeEventListener('click', this.handleClickOutside);
                this.filterText = null;
            }
        },
        propVal() {
            this.$emit('update:modelValue', this.propVal);
        }
    },
    beforeUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    },
};
</script>

<style scoped>
.custom-select {
    position: relative;
    display: inline-block;
    width: 100%;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
    padding: 4px 12px;
    box-shadow: 0 0 0 0.3px var(--el-border-color) inset;
    background-color: #fff;
    cursor: pointer;
}

.custom-select__selected {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: space-between;
    gap: 6px;
    min-height: 24px;
}

.custom-select__arrow {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    flex-shrink: 0;
}

.custom-select__arrow svg {
    width: 100%;
    height: 100%;
    color: var(--el-input-icon-color, var(--el-text-color-placeholder));
}

.custom-select__dropdown {
    position: absolute;
    top: 100%;
    z-index: 10;
    background: white;
    min-width: 840px;
    margin-top: 5px;
    border: 1px solid #ddd;
    border-radius: 5px;
    max-height: 200px;
    overflow-y: auto;
    left: 0; 
}

.custom-select__option {
    padding: 4px 12px;
    line-height: 1.5;
    cursor: pointer;
}

.custom-select__option:hover {
    background-color: #f2f2f2;
}

.text-wrap {
    white-space: normal;
    word-break: break-word;
    overflow-wrap: break-word;
    line-height: 1.3;
    flex: 1 1 auto;
    min-width: 0;
}

.custom-select.is-disabled {
    background-color: #f5f5f5;
    color: #aaa;
    cursor: not-allowed;
    pointer-events: none;
}
</style>
